let ja = {
    "translation" : {
        "has already been taken" : "アカウントの登録に失敗しました。メールアドレスが利用可能か確認ください。",
        "can't be blank" : "入力が必要です。",
        "login_error" : "ログインに失敗しました。メールアドレスが利用可能か確認ください。",
    }
};

export default ja;
